const message = {
    TotalText: "Total",
    ItemText: "items",
    UnnamedColumn: "Unnamed",
    EditTable: "Edit Table",
    RestoreDefault: "Restore Default",
    VisibleInfo: "Visible Columns",
    HiddenInfo: "Hidden Columns",
    Search: "Search",
    Cancel: "Cancel",
    Confirm: "Confirm",
    View: "View"
};

export default message;
